"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7784],{

/***/ 25887:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O2": function() { return /* binding */ getAllInputFieldsNames; },
/* harmony export */   "UM": function() { return /* binding */ inputValidate; },
/* harmony export */   "au": function() { return /* binding */ getInputDataByName; },
/* harmony export */   "zv": function() { return /* binding */ prePopulateInputsIfNeeded; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29815);
/* harmony import */ var _utils_url__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8339);
/* harmony import */ var _utils_url__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_utils_url__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _zendesk_service_zendesk_inputs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30257);



var inputValidate = function(inputData, inputValue) {
    var allInputsValues = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    var validate = inputData.validate, isRequired = inputData.isRequired, errorMessage = inputData.errorMessage, validateOnFormSubmission = inputData.validateOnFormSubmission;
    if (isRequired && !inputValue) return {
        isValid: false,
        errorMessage: "forms.requiredError"
    };
    var isSingleFieldValid = validate ? validate(inputValue) : true;
    var isFieldValidatedWithOtherFields = validateOnFormSubmission && allInputsValues ? validateOnFormSubmission(inputValue, allInputsValues) : true;
    var isValid = isSingleFieldValid && isFieldValidatedWithOtherFields;
    var msg = !isValid && (errorMessage || "forms.requiredError");
    return {
        isValid: isValid,
        errorMessage: msg
    };
};
var getAllInputFieldsNames = function(formConfig) {
    var rows = formConfig.rows;
    var inputsNames = new Set();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = rows[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var row = _step.value;
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = row[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var input = _step1.value;
                    var inputName = input.inputName;
                    inputsNames.add(inputName);
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(inputsNames);
};
var getInputDataByName = function(formConfig, name) {
    var rows = formConfig.rows;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = rows[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var row = _step.value;
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = row[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var input = _step1.value;
                    var inputName = input.inputName;
                    if (inputName === name) return input;
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return null;
};
var prePopulateInputsIfNeeded = function() {
    var inputs = {};
    var topicOverride = (0,_utils_url__WEBPACK_IMPORTED_MODULE_0__.getQueryParamValue)(window.location, _zendesk_service_zendesk_inputs__WEBPACK_IMPORTED_MODULE_1__/* .ZENDESK_TOPIC_INPUT_NAME */ .kE);
    if (topicOverride) {
        var topicLabel = (0,_zendesk_service_zendesk_inputs__WEBPACK_IMPORTED_MODULE_1__/* .getTopicOptionLabelByZendeskValue */ .HZ)(topicOverride);
        if (topicLabel) {
            inputs[_zendesk_service_zendesk_inputs__WEBPACK_IMPORTED_MODULE_1__/* .ZENDESK_TOPIC_INPUT_NAME */ .kE] = (0,_zendesk_service_zendesk_inputs__WEBPACK_IMPORTED_MODULE_1__/* .getTopicOptionLabelByZendeskValue */ .HZ)(topicOverride);
        }
    }
    return inputs;
};


/***/ }),

/***/ 30257:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HZ": function() { return /* binding */ getTopicOptionLabelByZendeskValue; },
/* harmony export */   "Hw": function() { return /* binding */ ZENDESK_EMAIL_INPUT_NAME; },
/* harmony export */   "LI": function() { return /* binding */ ZENDESK_TICKET_SUBJECT_NAME; },
/* harmony export */   "QA": function() { return /* binding */ ZENDESK_PHONE_NUM_INPUT_NAME; },
/* harmony export */   "bd": function() { return /* binding */ ZENDESK_LAST_NAME_INPUT_NAME; },
/* harmony export */   "dl": function() { return /* binding */ ZENDESK_FIRST_NAME_INPUT_NAME; },
/* harmony export */   "io": function() { return /* binding */ getZendeskFormConfig; },
/* harmony export */   "kE": function() { return /* binding */ ZENDESK_TOPIC_INPUT_NAME; },
/* harmony export */   "r_": function() { return /* binding */ ZENDESK_TICKET_CONTACT_CONSENT_CHECKBOX_NAME; },
/* harmony export */   "tH": function() { return /* binding */ ZENDESK_COMPANY_SIZE_INPUT_NAME; },
/* harmony export */   "vu": function() { return /* binding */ ZENDESK_TICKET_DESCRIPTION_NAME; },
/* harmony export */   "xU": function() { return /* binding */ getTopicZendeskValue; }
/* harmony export */ });
/* harmony import */ var client_services_form_service_form_inputs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var ZENDESK_FIRST_NAME_INPUT_NAME = "first_name";
var ZENDESK_LAST_NAME_INPUT_NAME = "last_name";
var ZENDESK_EMAIL_INPUT_NAME = "email";
var ZENDESK_PHONE_NUM_INPUT_NAME = "phone_num";
var ZENDESK_COMPANY_SIZE_INPUT_NAME = "company_size";
var ZENDESK_TOPIC_INPUT_NAME = "topic";
var ZENDESK_TICKET_SUBJECT_NAME = "subject";
var ZENDESK_TICKET_DESCRIPTION_NAME = "description";
var ZENDESK_TICKET_CONTACT_CONSENT_CHECKBOX_NAME = "contact_consent";
var TICKET_TOPIC_OPTIONS = [
    {
        label: "forms.zendesk.tickets.category.topic.gettingStarted",
        zendeskValue: "form_how_do_i"
    },
    {
        label: "forms.zendesk.tickets.category.topic.workflow",
        zendeskValue: "form_workflow_questions"
    },
    {
        label: "forms.zendesk.tickets.category.topic.billing",
        zendeskValue: "form_billing"
    },
    {
        label: "forms.zendesk.tickets.category.topic.automationsAndIntegrations",
        zendeskValue: "form_automations/integrations"
    },
    {
        label: "forms.zendesk.tickets.category.topic.appsMarketplace",
        zendeskValue: "form_apps/api_markteplace"
    },
    {
        label: "forms.zendesk.tickets.category.topic.notWorking",
        zendeskValue: "form_something_is_not_working"
    },
    {
        label: "forms.zendesk.tickets.category.topic.legalAndSecurity",
        zendeskValue: "form_legal_security"
    },
    {
        label: "forms.zendesk.tickets.category.topic.login",
        zendeskValue: "form_having_trouble_logging_in"
    },
    {
        label: "forms.zendesk.tickets.category.topic.signup",
        zendeskValue: "form_having_trouble_signup"
    },
    {
        label: "forms.zendesk.tickets.category.topic.featureRequest",
        zendeskValue: "form_feature_request"
    },
    {
        label: "forms.zendesk.tickets.category.topic.mobile",
        zendeskValue: "form_mobile"
    },
    {
        label: "forms.zendesk.tickets.category.topic.other",
        zendeskValue: "form_other"
    }
];
var getTicketTopicOptions = function() {
    return TICKET_TOPIC_OPTIONS.map(function(option) {
        return option.label;
    });
};
var getTopicZendeskValue = function(topicLabel) {
    var option = TICKET_TOPIC_OPTIONS.filter(function(option) {
        return option.label === topicLabel;
    })[0];
    return option === null || option === void 0 ? void 0 : option.zendeskValue;
};
var getTopicOptionLabelByZendeskValue = function(valueToFind) {
    var option = TICKET_TOPIC_OPTIONS.find(function(option) {
        return option.zendeskValue === valueToFind;
    });
    return option === null || option === void 0 ? void 0 : option.label;
};
var ZENDESK_FIRSTNAME_INPUT = _object_spread_props(_object_spread({}, client_services_form_service_form_inputs__WEBPACK_IMPORTED_MODULE_0__/* .FIRSTNAME_INPUT */ .oo), {
    inputName: ZENDESK_FIRST_NAME_INPUT_NAME,
    isRequired: true
});
var ZENDESK_LASTNAME_INPUT = _object_spread_props(_object_spread({}, client_services_form_service_form_inputs__WEBPACK_IMPORTED_MODULE_0__/* .LASTNAME_INPUT */ .Ce), {
    inputName: ZENDESK_LAST_NAME_INPUT_NAME,
    isRequired: true
});
var ZENDESK_EMAIL_INPUT = _object_spread_props(_object_spread({}, client_services_form_service_form_inputs__WEBPACK_IMPORTED_MODULE_0__/* .EMAIL_INPUT */ .I6), {
    inputName: ZENDESK_EMAIL_INPUT_NAME,
    isRequired: true
});
var ZENDESK_PHONE_INPUT = _object_spread_props(_object_spread({}, client_services_form_service_form_inputs__WEBPACK_IMPORTED_MODULE_0__/* .PHONE_INPUT */ .l5), {
    inputName: ZENDESK_PHONE_NUM_INPUT_NAME,
    isRequired: false,
    validate: null
});
var ZENDESK_COMPANYSIZE_INPUT = _object_spread_props(_object_spread({}, client_services_form_service_form_inputs__WEBPACK_IMPORTED_MODULE_0__/* .COMPANY_SIZE_INPUT */ .dN), {
    inputName: ZENDESK_COMPANY_SIZE_INPUT_NAME,
    isRequired: false
});
var ZENDESK_TOPIC_INPUT = {
    id: "topic",
    type: client_services_form_service_form_inputs__WEBPACK_IMPORTED_MODULE_0__/* .inputTypes.SELECT */ .Je.SELECT,
    title: "forms.zendesk.tickets.topicQuestion",
    options: getTicketTopicOptions(),
    inputName: ZENDESK_TOPIC_INPUT_NAME,
    isRequired: true,
    defaultValue: "forms.zendesk.tickets.topicQuestionPlaceholder"
};
var ZENDESK_TICKET_SUBJECT = {
    id: "subject",
    inputName: ZENDESK_TICKET_SUBJECT_NAME,
    type: client_services_form_service_form_inputs__WEBPACK_IMPORTED_MODULE_0__/* .inputTypes.TEXT */ .Je.TEXT,
    isRequired: true,
    title: "forms.zendesk.tickets.subjectQuestion"
};
var ZENDESK_DESCRIPTION_INPUT = {
    id: "description",
    inputName: ZENDESK_TICKET_DESCRIPTION_NAME,
    type: client_services_form_service_form_inputs__WEBPACK_IMPORTED_MODULE_0__/* .inputTypes.TEXT_AREA */ .Je.TEXT_AREA,
    isRequired: false,
    placeholder: "forms.zendesk.tickets.detailsPlacholder",
    title: "forms.zendesk.tickets.detailsQuestion"
};
var ZENDESK_CONTACT_CONSENT_CHECKBOX = _object_spread_props(_object_spread({}, client_services_form_service_form_inputs__WEBPACK_IMPORTED_MODULE_0__/* .CHECKBOX_INPUT */ .W6), {
    inputName: ZENDESK_TICKET_CONTACT_CONSENT_CHECKBOX_NAME,
    isRequired: false
});
var getZendeskFormConfig = function() {
    return {
        rows: [
            [
                ZENDESK_FIRSTNAME_INPUT,
                ZENDESK_LASTNAME_INPUT
            ],
            [
                ZENDESK_EMAIL_INPUT
            ],
            [
                ZENDESK_PHONE_INPUT,
                ZENDESK_COMPANYSIZE_INPUT
            ],
            [
                ZENDESK_TOPIC_INPUT
            ],
            [
                ZENDESK_TICKET_SUBJECT
            ],
            [
                ZENDESK_DESCRIPTION_INPUT
            ],
            [
                ZENDESK_CONTACT_CONSENT_CHECKBOX
            ]
        ]
    };
};


/***/ }),

/***/ 17784:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ base_form; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(10092);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./client/services/form-service/form-service.js
var form_service = __webpack_require__(25887);
// EXTERNAL MODULE: ./components/core/button/button-component.js + 5 modules
var button_component = __webpack_require__(20776);
// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var styled_jsx_style = __webpack_require__(60357);
var style_default = /*#__PURE__*/__webpack_require__.n(styled_jsx_style);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
;// CONCATENATED MODULE: ./constants/forms.js
/* harmony default export */ var constants_forms = ({
    FORM_INPUT_PADDING: 7
});

;// CONCATENATED MODULE: ./client/components/system/generic-form-input/generic-form-input.scss.js


var FORM_INPUT_PADDING = "".concat(constants_forms.FORM_INPUT_PADDING, "px");
var componentStyles = new String(".generic-form-input-component{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;.input-title{text-align:left;position:relative;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;margin-left:".concat(FORM_INPUT_PADDING, ";margin-bottom:10px;font-size:.875rem;font-weight:normal;line-height:19px;color:").concat(colors/* default.mud */.Z.mud, ';&.contact-form-required-input:after{content:"*";position:absolute;top:0px;right:-10px;color:').concat(colors/* default.brand-red */.Z["brand-red"], "}}.form-input-wrapper{position:relative;margin-bottom:32px;.required-error{position:absolute;color:").concat(colors/* default.brand-red */.Z["brand-red"], ";bottom:-18px;font-size:.8125rem;left:").concat(FORM_INPUT_PADDING, "}}}"));
componentStyles.__hash = "7bab8a1024c870e";

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./client/services/form-service/form-inputs.js + 18 modules
var form_inputs = __webpack_require__(5893);
;// CONCATENATED MODULE: ./client/components/system/generic-form-input/generic-form-input.js




function generic_form_input_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            generic_form_input_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}







var GenericFormInput = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(GenericFormInput, PureComponent);
    var _super = (0,_create_super/* default */.Z)(GenericFormInput);
    function GenericFormInput(props) {
        (0,_class_call_check/* default */.Z)(this, GenericFormInput);
        return _super.call(this, props);
    }
    (0,_create_class/* default */.Z)(GenericFormInput, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, inputData = _props.inputData, errorState = _props.errorState, translate = _props.translate, isV2 = _props.isV2, value = _props.value;
                var isRequired = inputData.isRequired, title = inputData.title, style = inputData.style, type = inputData.type, id = inputData.id, defaultValue = inputData.defaultValue, placeholder = inputData.placeholder;
                var isValid = errorState.isValid, errorMessage = errorState.errorMessage;
                var requiredTextLabel = translate(errorMessage);
                var InputComponent = (0,form_inputs/* getInputComponentByType */.$O)(type);
                var errorLabelId = "error_".concat(id);
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: _object_spread({}, style),
                    className: "jsx-".concat(componentStyles.__hash) + " " + "generic-form-input-component",
                    children: [
                        !isV2 && /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                            htmlFor: id,
                            className: "jsx-".concat(componentStyles.__hash) + " " + (classnames_default()("input-title", {
                                "contact-form-required-input": isRequired
                            }) || ""),
                            children: translate(title)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "jsx-".concat(componentStyles.__hash) + " " + "form-input-wrapper",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(InputComponent, _object_spread_props(_object_spread({
                                    id: id
                                }, this.props), {
                                    isRequired: isRequired,
                                    invalid: !isValid,
                                    errorLabelId: isValid ? null : errorLabelId,
                                    defaultValue: defaultValue || value,
                                    placeholder: isV2 ? translate(placeholder) : placeholder,
                                    className: "jsx-".concat(componentStyles.__hash) + " " + (this.props && this.props.className != null && this.props.className || "")
                                })),
                                !isValid && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    id: errorLabelId,
                                    className: "jsx-".concat(componentStyles.__hash) + " " + "required-error",
                                    children: requiredTextLabel
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                            id: componentStyles.__hash,
                            children: componentStyles
                        })
                    ]
                });
            }
        }
    ]);
    return GenericFormInput;
}(react.PureComponent);
GenericFormInput.defaultProps = {
    errorState: {
        isValid: true,
        errorMessage: null
    }
};
/* harmony default export */ var generic_form_input = ((0,generic_config_context/* withGenericConfig */.P)(GenericFormInput));

// EXTERNAL MODULE: ./constants/links.js + 20 modules
var links = __webpack_require__(27639);
// EXTERNAL MODULE: ./utils/react.js
var utils_react = __webpack_require__(12783);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
// EXTERNAL MODULE: ./segments/desktop/core-components/title/title.js + 1 modules
var title = __webpack_require__(91265);
// EXTERNAL MODULE: ./constants/sizes.js
var sizes = __webpack_require__(77869);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/regular-button/regular-button.js + 1 modules
var regular_button = __webpack_require__(35662);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(64487);
// EXTERNAL MODULE: ./services/bigbrain-service.js
var bigbrain_service = __webpack_require__(65488);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./client/services/hubspot-service/hubspot-constants.js
var hubspot_constants = __webpack_require__(22638);
;// CONCATENATED MODULE: ./segments/desktop/core-components/base-form/default-props.js
/* harmony default export */ var default_props = ({
    backgroundLayers: 0,
    submitFormAsyncCallback: function() {},
    submitScreenData: null,
    renderPrivacyNotice: false
});

// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
// EXTERNAL MODULE: ./segments/desktop/constants.js
var constants = __webpack_require__(73759);
;// CONCATENATED MODULE: ./segments/desktop/core-components/base-form/base-form.scss.js






var MAX_DESKTOP_CONTENT_WIDTH_PX = "".concat(vp_sizes/* MAX_DESKTOP_CONTENT_WIDTH */.O$, "px");
var base_form_scss_FORM_INPUT_PADDING = "".concat(constants_forms.FORM_INPUT_PADDING, "px");
var StyledLayeredBaseForm = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ebzl4910"
})("position:relative;.base-form{background:white;}.form-background-layer{position:absolute;height:100%;width:100%;background:", colors/* default.brand-dark-blue */.Z["brand-dark-blue"], ";border-radius:12px;}");
var StyledBaseForm = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ebzl4911"
})("padding:48px;background:", colors/* default.white */.Z.white, ";", (0,constants.getComponentShadow)(), "  border-radius:12px;margin:24px 12px;width:100%;text-align:center;.form-title-wrapper{margin-bottom:32px;text-align:left;}.form-subtitle-wrapper{display:flex;justify-content:space-between;color:", colors/* default */.Z[color_consts.BRAND_BLACK_TEXT_COLOR], ";margin-bottom:12px;width:386px;margin-left:4px;.form-back-button{display:flex;font-size:1rem;cursor:pointer;align-items:center;gap:4px;.picture-component{display:flex;img{height:12px;}}}.paragraph-wrapper .paragraph-body{font-size:1rem;}}.error-wrapper{margin:0 6px 16px 6px;.form-error{width:100%;display:flex;text-align:left;font-size:0.8125rem;color:", colors/* default.brand-red */.Z["brand-red"], ";}}.contact-form-row{display:flex;justify-content:space-evenly;align-items:flex-end;.form-input-wrapper{font-size:0.875rem;flex-grow:1;padding-left:", base_form_scss_FORM_INPUT_PADDING, ";padding-right:", base_form_scss_FORM_INPUT_PADDING, ";}}.contact-form-thanks{display:flex;flex-direction:column;justify-content:center;align-items:center;color:", colors/* default.mud */.Z.mud, ";padding:40px 0 100px 0;.contact-form-thanks-title{font-weight:500;font-size:1.75rem;line-height:37px;padding:16px;}.contact-form-thanks-content{font-size:0.875rem;line-height:24px;display:flex;flex-direction:column;padding-top:8px;.contact-form-thanks-footer{padding-top:32px;.contact-form-footer-link{padding:0 4px;}}.download-button-wrapper{padding-top:20px;}}.submit-image{width:253px;}}.react-tel-input{text-align:left;height:40px;input{margin-left:35px;width:calc(100% - 35px);height:40px;padding-left:16px;&.input-required{position:relative;border-color:", colors/* default.brand-red */.Z["brand-red"], " !important;}&:focus{border-color:", colors/* default.basic-blue */.Z["basic-blue"], " !important;}}.react-tel-input .country-list{margin:3px 0 10px -1px;text-align:left;}}.privacy-notice-wrapper{display:flex;justify-content:center;font-size:0.8125rem;line-height:16px;padding-bottom:16px;.privacy-notice{max-width:300px;}}@media (max-width:", MAX_DESKTOP_CONTENT_WIDTH_PX, "){margin:16px 0;padding:24px 16px;.contact-form-row{flex-direction:column;align-items:baseline;.form-input-wrapper{width:100%;}}}");

// EXTERNAL MODULE: ./constants/input-validations-patterns.js
var input_validations_patterns = __webpack_require__(18455);
// EXTERNAL MODULE: ./client/services/form-service/form-constants.js
var form_constants = __webpack_require__(24065);
// EXTERNAL MODULE: ./contexts/ab-tests-context.js
var ab_tests_context = __webpack_require__(24492);
;// CONCATENATED MODULE: ./segments/desktop/core-components/base-form/base-form.js


function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function base_form_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property1(target, key, source[key]);
        });
    }
    return target;
}
function base_form_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function base_form_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        base_form_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}























var DONE_ASSET_SRC = "/static/img/done_asset.png";
var MAX_BACKGROUND_LAYERS = 3;
var BACKGROUND_LAYER_MARGIN = 12;
var BaseForm = function(props) {
    var onInputBlur = props.onInputBlur, onEmailChange = props.onEmailChange, formConfig = props.formConfig, isV2 = props.isV2, translate = props.translate, translateWithParam = props.translateWithParam, submitScreenData = props.submitScreenData, renderPrivacyNotice = props.renderPrivacyNotice, submitFormAsyncCallback = props.submitFormAsyncCallback, dontRenderPostFormSubmit = props.dontRenderPostFormSubmit;
    var ref = (0,react.useState)({}), inputs = ref[0], setInputs = ref[1];
    var ref1 = (0,react.useState)({}), errorState = ref1[0], setErrorState = ref1[1];
    var ref2 = (0,react.useState)(false), isLoading = ref2[0], setIsLoading = ref2[1];
    var ref3 = (0,react.useState)(false), hasFormSubmitted = ref3[0], setHasFormSubmitted = ref3[1];
    var ref4 = (0,react.useState)(false), formError = ref4[0], setFormError = ref4[1];
    var ref5 = (0,react.useState)(null), formSubmitErrorMessage = ref5[0], setFormSubmitErrorMessage = ref5[1];
    var ref6 = (0,react.useState)(props.backgroundLayers), backgroundLayers = ref6[0], setBackgroundLayers = ref6[1];
    var allInputsNames = (0,react.useMemo)(function() {
        return (0,form_service/* getAllInputFieldsNames */.O2)(formConfig);
    }, [
        formConfig
    ]);
    (0,react.useEffect)(function() {
        var prePopulatedInputs = (0,form_service/* prePopulateInputsIfNeeded */.zv)();
        if (Object.keys(prePopulatedInputs).length > 0) {
            setInputs(base_form_object_spread({}, inputs, prePopulatedInputs));
        }
    }, []);
    var onInputChange = function(param) {
        var target = param.target;
        var name = target.name, value = target.value;
        setInputs(function(prevState) {
            return base_form_object_spread_props(base_form_object_spread({}, prevState), (0,_define_property/* default */.Z)({}, name, value));
        });
        setErrorState(function(prevState) {
            return base_form_object_spread_props(base_form_object_spread({}, prevState), (0,_define_property/* default */.Z)({}, name, {
                isValid: true
            }));
        });
    };
    var onFormInputBlur = function(param) {
        var target = param.target;
        var name = target.name, value = target.value;
        if (onInputBlur) {
            onInputBlur(name, value);
        }
        if (name === form_inputs/* inputTypes.EMAIL */.Je.EMAIL) {
            input_validations_patterns/* EMAIL_PATTERN.test */.Q.test(value) && onEmailChange(value);
        }
        validateInputOnBlur(name);
    };
    var focusOnFirstInvalidElement = function() {
        var _ariaInvalidInputs_;
        var ariaInvalidInputs = document.querySelectorAll('[aria-invalid="true"]');
        ariaInvalidInputs && ((_ariaInvalidInputs_ = ariaInvalidInputs[0]) === null || _ariaInvalidInputs_ === void 0 ? void 0 : _ariaInvalidInputs_.focus());
    };
    var validateInputOnBlur = function(inputName) {
        var inputValue = inputs[inputName];
        var inputData = (0,form_service/* getInputDataByName */.au)(formConfig, inputName);
        var isRequired = inputData.isRequired, validate = inputData.validate;
        if (!isRequired && !validate) return;
        var ref = (0,form_service/* inputValidate */.UM)(inputData, inputValue), isValid = ref.isValid, errorMessage = ref.errorMessage;
        setErrorState(base_form_object_spread_props(base_form_object_spread({}, errorState), (0,_define_property/* default */.Z)({}, inputName, {
            isValid: isValid,
            errorMessage: errorMessage
        })));
    };
    var validateInputs = function() {
        var newErrorState = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = allInputsNames[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var inputName = _step.value;
                var inputValue = inputs[inputName];
                var inputData = (0,form_service/* getInputDataByName */.au)(formConfig, inputName);
                var ref = (0,form_service/* inputValidate */.UM)(inputData, inputValue, inputs), isValid = ref.isValid, errorMessage = ref.errorMessage;
                if (!isValid) newErrorState[inputName] = {
                    isValid: isValid,
                    errorMessage: errorMessage
                };
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        setErrorState(newErrorState);
        setTimeout(function() {
            focusOnFirstInvalidElement();
        }, 0);
        return Object.keys(newErrorState).length > 0;
    };
    var renderInputList = function() {
        var rows = formConfig.rows;
        return rows.map(function(row, rowIndex) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "contact-form-row",
                children: row.map(function(inputData) {
                    var inputName = inputData.inputName, style = inputData.style;
                    var value = inputs[inputName];
                    var hasError = errorState[inputName];
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "form-input-wrapper",
                        style: base_form_object_spread({}, style),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(generic_form_input, {
                            inputData: inputData,
                            value: value,
                            errorState: hasError,
                            onInputChange: onInputChange,
                            onInputBlur: onFormInputBlur,
                            isV2: isV2
                        })
                    }, "input_".concat(inputName));
                })
            }, "input_row_".concat(rowIndex));
        });
    };
    var getHelpCenterLinkHTML = function() {
        return '<a href="'.concat(links/* HELP_CENTER_LINK */.j3e, '" target="_blank">\n      ').concat(translate("forms.thanksPage.helpCenter"), "</a>");
    };
    var isSmallCompany = function() {
        var _inputs_HUBSPOT_API_COMPANY_SIZE;
        return ((_inputs_HUBSPOT_API_COMPANY_SIZE = inputs[hubspot_constants/* HUBSPOT_API_COMPANY_SIZE */.h4]) === null || _inputs_HUBSPOT_API_COMPANY_SIZE === void 0 ? void 0 : _inputs_HUBSPOT_API_COMPANY_SIZE.value) === form_constants/* SMALLEST_COMPANY_SIZE */.oP;
    };
    var getSubmitScreenSubTitle = function() {
        var subTitleHtmlKey = submitScreenData === null || submitScreenData === void 0 ? void 0 : submitScreenData.subTitleHtmlKey;
        if (translate(subTitleHtmlKey)) {
            return translate(subTitleHtmlKey);
        }
        if (isSmallCompany()) {
            return translate("forms.thanksPage.smallCompany.subTitle");
        }
        return translate("forms.thanksPage.subTitle");
    };
    var getSubmitScreenData = function() {
        var footerLinkHtml = (submitScreenData === null || submitScreenData === void 0 ? void 0 : submitScreenData.footerLinkHtml) || getHelpCenterLinkHTML();
        return {
            postSubmitAssetSrc: (submitScreenData === null || submitScreenData === void 0 ? void 0 : submitScreenData.postSubmitAssetSrc) || DONE_ASSET_SRC,
            title: translate(submitScreenData === null || submitScreenData === void 0 ? void 0 : submitScreenData.titleKey) || translate("forms.thanksPage.title"),
            subTitleHtml: getSubmitScreenSubTitle(),
            footerHtml: translate(submitScreenData === null || submitScreenData === void 0 ? void 0 : submitScreenData.footerHtml) || translateWithParam("forms.thanksPage.footer", footerLinkHtml),
            downloadButtonLink: (submitScreenData === null || submitScreenData === void 0 ? void 0 : submitScreenData.downloadButtonLink) || false
        };
    };
    var renderPostFormSubmit = function() {
        var submitScreenData = getSubmitScreenData();
        var DownloadButtonText = translate("forms.thanksPage.gartnerCampaign.buttonText");
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "contact-form-thanks",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                    src: submitScreenData.postSubmitAssetSrc,
                    className: "submit-image",
                    isDecorative: true
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "contact-form-thanks-title",
                    children: submitScreenData === null || submitScreenData === void 0 ? void 0 : submitScreenData.title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "contact-form-thanks-content",
                    children: [
                        submitScreenData.subTitleHtml && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            dangerouslySetInnerHTML: {
                                __html: submitScreenData.subTitleHtml
                            }
                        }),
                        submitScreenData.footerHtml && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "contact-form-thanks-footer",
                            dangerouslySetInnerHTML: {
                                __html: submitScreenData.footerHtml
                            }
                        }),
                        (submitScreenData === null || submitScreenData === void 0 ? void 0 : submitScreenData.downloadButtonLink) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "download-button-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(regular_button/* default */.Z, {
                                color: color_consts.WORK_OS_IRIS_COLOR_NAME,
                                url: submitScreenData === null || submitScreenData === void 0 ? void 0 : submitScreenData.downloadButtonLink,
                                isOpenLinkInNewTab: true,
                                buttonText: DownloadButtonText
                            })
                        })
                    ]
                })
            ]
        });
    };
    var getPrivacyHtml = function() {
        var privacyNoticeText = formConfig.privacyNoticeText;
        var privacyPolicyLink = '<a href="'.concat(links/* PRIVACY_POLICY_LINK */.jbE, '" target="_blank">\n      ').concat(translate("forms.privacyPolicy"), "</a>");
        if (privacyNoticeText) return translateWithParam(privacyNoticeText, privacyPolicyLink);
        return translateWithParam("forms.privacyNoticeShorten", privacyPolicyLink);
    };
    var renderPrivacyNoticeIfNeeded = function() {
        if (!renderPrivacyNotice) {
            return null;
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "privacy-notice-wrapper",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "privacy-notice",
                dangerouslySetInnerHTML: {
                    __html: getPrivacyHtml()
                }
            })
        });
    };
    var renderErrorIfNeeded = function() {
        if (!formError) return null;
        var errorMessage = formSubmitErrorMessage || "form.errors.formSubmitError";
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "error-wrapper",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "form-error",
                role: "alert",
                children: translate(errorMessage)
            })
        });
    };
    var renderForm = function() {
        var submitButtonText = formConfig.submitButtonText, ctaProps = formConfig.ctaProps, formTitle = formConfig.formTitle;
        var buttonText = translate((ctaProps === null || ctaProps === void 0 ? void 0 : ctaProps.overrideText) || submitButtonText || "forms.defaultSubmitButton");
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                formTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "form-title-wrapper",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(title/* default */.Z, {
                        title: formTitle,
                        titleSize: sizes.XS
                    })
                }),
                renderInputList(),
                renderErrorIfNeeded(),
                renderPrivacyNoticeIfNeeded(),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(button_component/* default */.Z, {
                    color: (ctaProps === null || ctaProps === void 0 ? void 0 : ctaProps.color) || color_consts.WORK_OS_IRIS_COLOR_NAME,
                    invert: ctaProps === null || ctaProps === void 0 ? void 0 : ctaProps.invert,
                    isLoading: isLoading,
                    onClickCallback: onButtonClick,
                    children: buttonText
                })
            ]
        });
    };
    var getFormData = function() {
        var formData = [];
        for(var input in inputs){
            formData.push({
                name: input,
                value: inputs[input]
            });
        }
        return formData;
    };
    var onButtonClick = function() {
        var _ref = _async_to_generator(function() {
            var hasErrors, formData, formResponse, urlToRedirectAfterSubmission;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        hasErrors = validateInputs();
                        if (hasErrors) {
                            return [
                                2
                            ];
                        }
                        formData = getFormData();
                        setIsLoading(true);
                        setFormError(false);
                        setFormSubmitErrorMessage(null);
                        return [
                            4,
                            submitFormAsyncCallback(formData)
                        ];
                    case 1:
                        formResponse = _state.sent();
                        urlToRedirectAfterSubmission = formResponse === null || formResponse === void 0 ? void 0 : formResponse.redirectUrl;
                        if (!urlToRedirectAfterSubmission) {
                            setIsLoading(false);
                        }
                        if (!(formResponse === null || formResponse === void 0 ? void 0 : formResponse.success)) {
                            setFormError(true);
                            setFormSubmitErrorMessage(formResponse === null || formResponse === void 0 ? void 0 : formResponse.errorMessage);
                            esm_exports/* captureException */.Tb("Contact sales form submission failed: ".concat(formResponse === null || formResponse === void 0 ? void 0 : formResponse.errorMessage, ". Form data: ").concat(JSON.stringify(formData)));
                            (0,bigbrain_service.trackEvent)(bigbrain_event_types.CONTACT_SALES_FORM_SUBMISSION_CALL_FAILED, {
                                info1: formResponse === null || formResponse === void 0 ? void 0 : formResponse.errorMessage,
                                data: formData
                            });
                            return [
                                2
                            ];
                        }
                        setHasFormSubmitted(true);
                        if (urlToRedirectAfterSubmission) {
                            window.location.href = urlToRedirectAfterSubmission;
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function onButtonClick() {
            return _ref.apply(this, arguments);
        };
    }();
    var renderBackgroundLayers = function() {
        setBackgroundLayers(Math.min(backgroundLayers, MAX_BACKGROUND_LAYERS));
        var layers = Array(backgroundLayers).fill().map(function(element, index) {
            return index + 1;
        });
        return layers.map(function(layer) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "form-background-layer",
                style: {
                    zIndex: -1 * layer,
                    marginTop: BACKGROUND_LAYER_MARGIN * layer,
                    marginLeft: -BACKGROUND_LAYER_MARGIN * (layer - 1),
                    opacity: 1 - 0.25 * layer
                }
            }, "bg_layer_".concat(layer));
        });
    };
    var shouldRenderPostFormSubmit = !dontRenderPostFormSubmit && hasFormSubmitted;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(utils_react/* ConditionalWrapper */.M, {
        condition: backgroundLayers,
        wrapper: function(children) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledLayeredBaseForm, {
                className: "layered-base-form",
                children: [
                    renderBackgroundLayers(),
                    children
                ]
            });
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledBaseForm, {
            className: "base-form",
            children: [
                shouldRenderPostFormSubmit && renderPostFormSubmit(),
                !shouldRenderPostFormSubmit && renderForm()
            ]
        })
    });
};
BaseForm.defaultProps = default_props;
/* harmony default export */ var base_form = ((0,ab_tests_context/* withAbTests */.k)((0,generic_config_context/* withGenericConfig */.P)(BaseForm)));


/***/ })

}]);